export enum DownloadItemType {
    PDF,
    EXCEL,
    ARCHIVE,
    WORD
}
